import { useEffect, useMemo, useState } from 'react'
import { shopSetupStatusService } from 'src/api/shop'
import { LAUNCH_STEPS, LAUNCH_STEP_IDS } from '../constants'

/**
 * `GET Shop/setup-status` field for each launch step. The backend computes
 * the done state from workspace data on every call (nothing is stored;
 * undoing a step reopens it):
 * - branding: a workspace logo is uploaded
 * - portal: the portal landing page was saved at least once
 * - firstCourse: at least one course in the workspace, drafts included
 * - connectAi: any workspace member has an active MCP connection
 */
const STATUS_FIELDS = {
  [LAUNCH_STEP_IDS.BRANDING]: 'branding',
  [LAUNCH_STEP_IDS.PORTAL]: 'portal',
  [LAUNCH_STEP_IDS.FIRST_COURSE]: 'firstCourse',
  [LAUNCH_STEP_IDS.CONNECT_AI]: 'connectAi',
}

/**
 * Launch steps with `done` and `current` (the first step that is not done;
 * none when all are done). Steps stay open if the request fails.
 */
const useLaunchProgress = () => {
  const [status, setStatus] = useState({})

  useEffect(() => {
    let cancelled = false
    shopSetupStatusService()
      .then(response => {
        if (!cancelled) setStatus(response?.data || {})
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [])

  return useMemo(() => {
    const isDone = step => Boolean(status[STATUS_FIELDS[step.id]])
    const currentIndex = LAUNCH_STEPS.findIndex(step => !isDone(step))
    return LAUNCH_STEPS.map((step, index) => ({
      ...step,
      number: index + 1,
      done: isDone(step),
      current: index === currentIndex,
    }))
  }, [status])
}

export default useLaunchProgress
